import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Loader from "./Loader";
import {useContext} from 'react';
import {ButtonVisibilityContext} from '../../Context/ButtonVisibilityContext';
import { Box, IconButton, TextField, Paper } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SendIcon from "@mui/icons-material/Send";
import {POST_SENDMESSAGE} from '../../constants'


function ChatDialog({ open, setOpen, chatMessageData, custChats, loading, setLoading, messageLoading }) {
   const {setShowButton} = useContext(ButtonVisibilityContext);
   const [message, setMessage] = useState("");
  const handleClose = () => {
    setOpen(false);
    setShowButton(true);
  };

const userPhoneNo = JSON.parse(localStorage.getItem('userMobileNo'));
// console.log("userPhoneNo",userPhoneNo)
const empId = custChats.BDMId;
const empPhone = userPhoneNo;

const sendMessage = async () => {
  if(!message.trim()){
    console.warn("message is empty. type somthingn...");
    return;
  }

  const payload = {
    mobile_no: empPhone,
    message: message,
    employeeId: empId
  };
 
  try {
    const response = await axios.post(`${POST_SENDMESSAGE}`, payload,{headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        }},);
    console.log("Message sent successfully:", response.data);
    setMessage("");
  } catch (error) {
    console.error("Error sending message:", error);
  }
};

  if (!open) return null;

  return (
    <>
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-70">
    <div className="bg-slate-400 rounded-lg w-full h-full sm:max-w-2xl sm:max-h-[90vh] flex flex-col shadow-lg">
        
        {/* Header */}
        <div className="relative mt-14 bg-white px-6 py-4 border-b-4 border-[#ff7e5f] text-center font-bold">
          Chat - {custChats?.CustomerName ?? ''}
          <button
            onClick={handleClose}
            className="absolute right-4 top-4 text-black hover:text-gray-600"
          >
            ✕
         </button>
        </div>
        <div className="flex-1 overflow-y-auto bg-gray-100 p-4 flex flex-col gap-3 mb-10">
          {loading ? (<div className="text-center text-gray-500">Loading...</div>) :   chatMessageData && chatMessageData.length > 0 ? (
            chatMessageData.map((chat, index) => {
              const formattedTime = new Date(chat?.message_time).toLocaleString('en-US', {
              dateStyle: 'short',
              timeStyle: 'short',
});
         return(
          <div
  key={index}
  className={`max-w-[70%] px-4 py-2 rounded-2xl break-words shadow-md ${
  chat?.sender === "employee"
    ? 'bg-[#0f6653] text-white self-end'
    : 'bg-gray-200 text-black self-start'
} flex flex-col gap-1`}
>
  {/* <div className="font-semibold">{chat?.sender}</div> */}
  {chat?.message?.toLowerCase().endsWith(".pdf") ? (
    <div className="mt-2 flex gap-2 items-center justify-start">
      <img
        src="https://cdn-icons-png.flaticon.com/512/337/337946.png"
        alt="PDF Preview"
        className="w-10 h-10 object-cover cursor-pointer"
        onClick={() => window.open(`${chat.message}`, "_blank")}
      />
      <a
        href={`${chat.message}`}
        download
        target="_blank"
        rel="noopener noreferrer"
        className="block text-blue-500 underline mt-1 text-sm"
      >
        Download PDF
      </a>
    </div>
  ) : /\.(jpe?g|png|gif|webp)$/i.test(chat?.message) ? (
    <img
      src={`${chat.message}`}
      alt="Image"
      className="max-w-full h-auto mt-2 rounded cursor-pointer"
      onClick={() => window.open(`${chat.message}`, "_blank")}
    />
  ) : (
    <div className="mt-1">{chat?.message}</div>
  )}

  <div className="text-xs text-right mt-1">{formattedTime}</div>
</div>
              )
               })
          ) : (
            <div className="text-center text-gray-500">No messages yet.</div>
          ) }
        
          <div className='mb-20'>
        <Box
      sx={{
        position: "fixed",
        bottom: 80,
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        zIndex: 100,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          display: "flex",
          alignItems: "center",
          width: "90%",
          maxWidth: 600,
          padding: "4px 8px",
          borderRadius: "24px",
        }}
      >
        <IconButton>
          <MoreVertIcon />
        </IconButton>

        <TextField
          placeholder="Type a message..."
          variant="standard"
          fullWidth
          value={message}  // What shows in the input comes from state
          onChange={(e) => setMessage(e.target.value)}  // Update state on typing
          InputProps={{
            disableUnderline: true,
          }}
          sx={{ mx: 1 }}
        />

        <IconButton onClick={()=>sendMessage()}>
          <SendIcon />
        </IconButton>
      </Paper>
    </Box>
        </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default ChatDialog;
